'use client'

import { useState } from 'react'

import Button from '@/components/Button/Button'

import { useAuth } from './AuthContext'

import Scopes from '@/data/scopes.json'

import styles from './Auth.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export default function OAuthConsentForm() {
    const { oauthParams, oauthClientData, approveOAuthConsent, denyOAuthConsent } = useAuth()
    const [loading, setLoading] = useState(false)

    const handleApprove = async () => {
        if (loading) return
        setLoading(true)
        try {
            await approveOAuthConsent()
        } catch (error) {
            console.error('Error approving OAuth consent:', error)
        } finally {
            setLoading(false)
        }
    }

    const handleDeny = () => {
        if (loading) return
        denyOAuthConsent()
    }

    // Parse scopes from space-separated string
    const scopes = oauthParams?.scope ? oauthParams.scope.split(' ') : []

    // Get a friendly client name from client data
    const getClientName = () => {
        return oauthClientData?.name || oauthParams?.client_id || 'Unknown Application'
    }

    // Get friendly scope names
    const getScopeName = (scope) => {
        return Scopes[scope] || scope
    }

    return (
        <>
            <div className={classes('form')}>
                {oauthClientData?.logoUrl && (
                    <img src={oauthClientData.logoUrl} alt={getClientName()} className={classes('client-logo')} />
                )}
                <h1 className={classes('title')}>Authorisation Request</h1>
                <p className={classes('subtext')}>
                    <strong>{getClientName()}</strong> would like to access your account
                </p>
                {oauthClientData?.description && (
                    <p className={classes('client-description')}>{oauthClientData.description}</p>
                )}

                {scopes.length > 0 && (
                    <div className={classes('oauth-scopes')}>
                        <p className={classes('scopes-title')}>This application will be able to:</p>
                        <ul className={classes('scopes-list')}>
                            {scopes.map((scope) => (
                                <li key={scope}>{getScopeName(scope)}</li>
                            ))}
                        </ul>
                    </div>
                )}

                <p className={classes('oauth-warning')}>
                    By authorising this application, you allow it to access the specified data on your behalf. You can
                    revoke this access at any time from your account settings.
                </p>
            </div>

            <div className={classes('oauth-buttons')}>
                <Button
                    className={classes('deny-button')}
                    onClick={handleDeny}
                    text="Deny"
                    disabled={loading}
                    type="white-gray"
                    fullWidth
                />
                <Button
                    className={classes('approve-button')}
                    onClick={handleApprove}
                    text={loading ? 'Authorising...' : 'Authorise'}
                    disabled={loading}
                    fullWidth
                />
            </div>
        </>
    )
}
